import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import StackingPageHeader from "../../components/StackingPageHeader";
import StackingCardList from "../../components/StackingCardList";
import {
  fetchStakingContract,
  fetchStakingContractWithUser,
} from "../../store/stakingStore";
import { useEthers } from "@usedapp/core";
function StakingPage() {
  const dispatch = useDispatch();
  const {library} = useEthers()
  useEffect(() => {
    dispatch(fetchStakingContract({provider:library}));
    dispatch(fetchStakingContractWithUser({provider:library}));
  }, [dispatch, library]);
  return (
    <>
      <StackingPageHeader />
      <StackingCardList />
    </>
  );
}

export default React.memo(StakingPage);
